module.exports = __webpack_public_path__ + "img/ic_32_sport_fussball-active.3ae57ee9.svg";